// Translation: Interface > Pagination (English)
export default Object.freeze({
	options: {
		first: {
			label: 'First'
		},
		last: {
			label: 'Last'
		},
		next: {
			label: 'Next'
		},
		previous: {
			label: 'Previous'
		}
	}
})
